<nz-card [nzTitle]="'Agentes'"  *ngIf="!editing">
  <div class="lista-topo">
    <input 
      nz-input 
      nzPlaceHolder="Buscar por nome do agente..."
      [(ngModel)]="searchText"
      nzSize="large"
      class="lista-busca">
    <button 
      nz-button 
      nzType="primary" 
      nzSize="large"
      (click)="createAgent()">
      + Novo Agente
    </button>
     <button 
      nz-button 
      nzType="primary" 
      nzSize="large"
      (click)="refreshAgents()">
      Atualizar
    </button>
  </div>
  
  <div class="table-wrapper">
    <nz-table 
      [nzData]="filteredAgents" 
      nzBordered 
      [nzNoResult]="emptyTemplate"
      [nzLoading]="loading"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="10"
      class="full-table"
      #tableAgent
      nzTableLayout="fixed"

      [nzScroll]="{ y: '100px' }">
      <thead>
        <tr>
          <th>{{'agentBuilder.name'|translateTA}}</th>
          <th>{{'agentBuilder.llm'|translateTA}}</th>
          <th>{{'agentBuilder.model'|translateTA}}</th>
          <th>{{'agentBuilder.company'|translateTA}}</th>
          <th>{{'agentBuilder.contract'|translateTA}}</th>
          <th>{{'agentBuilder.modifiedOn'|translateTA}}</th>
          <th nzWidth="110px">{{'agentBuilder.situation'|translateTA}}</th>
          <th>{{'agentBuilder.actions'|translateTA}}</th>
        </tr>
      </thead>
      <tbody>
         @for (agent of tableAgent.data; track agent._id) {
         <tr>
           @let icon = getIcon(agent);
          <td>{{ agent.agentName }}</td>
          <td><nz-icon [nzType]="icon" nzTheme="outline"></nz-icon> {{ agent.llm }}</td>
          <td>{{ agent.model }}</td>
          <!-- agente gravado sem empresa ou contrato derrubava a linha inteira:
               os dois campos so existem quando alguem os preencheu na tela -->
          <td>{{ agent.codecompany?.key }} {{ agent.codecompany?.value ? '- ' + agent.codecompany.value : '' }}</td>
          <td>{{ agent.codecontract?.key }} {{ agent.codecontract?.value ? '- ' + agent.codecontract.value : '' }}</td>
          <td>{{ (agent.RECMODIFIEDON) }}</td>

          <!-- Situacao: agente desligado nao roda, e o autonomo aparece separado
               porque so ele depende do cron e do servidor -->
          <td>
            @if (agent.active === false) {
              <nz-tag>{{'agentBuilder.inactive'|translateTA}}</nz-tag>
            } @else if (agent.autonomo === true) {
              <nz-tag nzColor="blue">{{'agentBuilder.autonomoTag'|translateTA}}</nz-tag>
            } @else {
              <nz-tag nzColor="green">{{'agentBuilder.activeTag'|translateTA}}</nz-tag>
            }
          </td>
          <td style="white-space: nowrap;">
            <button 
              nz-button 
              nzType="primary" 
              nzSize="small"
              (click)="editAgent(agent)"
              style="margin-right: 8px">
              Editar
            </button>
            <button 
              nz-button 
              nzType="default" 
              nzSize="small"
              (click)="cloneAgent(agent)"
              style="margin-right: 8px">
              Clonar
            </button>
            <button 
              nz-button 
              nzDanger 
              nzSize="small"
              (click)="deleteAgent(agent)">
              Deletar
            </button>
          </td>
        </tr>
        }
      </tbody>
    </nz-table>
  </div>
</nz-card>
<agent-builder-config *ngIf="editing" [form]="form" [editSubject]="editSubject" ></agent-builder-config>

<ng-template #emptyTemplate >
           <nz-empty 
              nzNotFoundContent="Nenhum agente encontrado"
              style="margin: 0">
            </nz-empty>
</ng-template>